export const environment = {
  rootUrl: `${process.env.https://api.digitalbuildings.ai}/core`,
  keycloakUrl: `${process.env.https://users.digitalbuildings.xyz}/auth`,
  keycloakServiceUrl: process.env.https://api.digitalbuildings.ai,
  keycloakRealm: 'zdb',
  keycloakClientId: 'core-edit-2',
  gatewayUrl: process.env.https://api.digitalbuildings.ai
}
